import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { chatJobsKey } from "~/entities/chat/useActiveChat";

const POLL_INTERVAL_MS = 15_000;

// Smart fallback: каллер сам решает, нужен ли interval (обычно —
// `hasInFlightJobs && !sse.isConnected`). Когда SSE здоров —
// 0 фоновых запросов. Когда стрим отвалился — раз в 15s
// перепроверяем jobs до тех пор, пока SSE не поднимется обратно.
//
// Только jobs, без messages — список сообщений на статус генерации
// не влияет, и инвалидация messages раз в 15s гнала лишний
// `messages?limit=100` запрос.
export function useJobsPolling(chatId: string | null | undefined, enabled: boolean): void {
    const qc = useQueryClient();

    useEffect(() => {
        if (!chatId || !enabled) return;

        const tick = () => {
            void qc.invalidateQueries({ queryKey: chatJobsKey(chatId) });
        };

        const id = window.setInterval(tick, POLL_INTERVAL_MS);
        return () => window.clearInterval(id);
    }, [chatId, enabled, qc]);
}
